import React, { useEffect, useState } from "react";
import TmsTable from "../../../../../components/tms-customs/tms-table";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router";
import TmsDarshanamService from "../../../../../services/tms-darshanam/tms-darshanam.service";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error";
import { Button, Checkbox, Col, Row, Switch } from "antd";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-all.scss";
import TmsDInnerPagesAnd from "./tms-d-inner-pages-and";
import TmsDInnerPagesActions from "../../../../../components/tms-service-management/tms-sm-darshanam/tms-d-inner-pages-actions";
import TextArea from "antd/lib/input/TextArea";
import TmsDrawer from "../../../../../components/tms-customs/tms-drawer";

const TmsDInnerPagesAll = ({ router }) => {
  const [updateFlag, setUpdateFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [darshanamData, setDarshanamData] = useState([]);
  const [tmsModalVisible, settmsModalVisible] = useState(false);
  const [viewDarshanamData, setViewDarshanamData] = useState();
  const [editFlag, setEditFlag] = useState();
  const [productId, setProductId] = useState();
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [termsData, setTermsData] = useState([]);
  const [onlinetermsData, setOnlineTermsData] = useState([]);
  const [miniTicket, setMiniTicket] = useState(false);

  const tableColums = [
    ["Name", viewDarshanamData?.name],
    ["Description", viewDarshanamData?.description],
    ["Max POS Bookings", viewDarshanamData?.maxCounterBookings],
    ["Max Online Bookings", viewDarshanamData?.maxOnlineBookings],
    ["Min Online (Hours)", Number(viewDarshanamData?.minOnlineHours)],
    ["Max Online (Hours)", Number(viewDarshanamData?.maxOnlineHours)],
    ["Min POS (Hours)", viewDarshanamData?.minCounterHours],
    ["Max POS (Hours)", viewDarshanamData?.maxCounterHours],
    [
      "POS-(Status)",
      viewDarshanamData?.counterEnabled ? "enabled" : "disabled",
    ],
    [
      "Online-(Status)",
      viewDarshanamData?.onlineEnabled ? "enabled" : "disabled",
    ],
    ["Price", viewDarshanamData?.price],
  ];

  const switchTrigger = async (key) => {
    setLoading(true);
    try {
      const darData = await TmsDarshanamService.viewDarshanam(key);
      setViewDarshanamData(darData);
      settmsModalVisible(true);
      setEditFlag(true);
      setProductId(key);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    // try {
    //   const darData = await TmsDarshanamService.viewDarshanam(key);

    //   let body = {
    //     maxCounterBookings: darData?.maxCounterBookings,
    //     maxOnlineBookings: darData?.maxOnlineBookings,
    //     minOnlineHours: darData?.minOnlineHours / 24,
    //     maxOnlineHours: darData?.maxOnlineHours / 24,
    //     minCounterHours: darData?.minCounterHours,
    //     maxCounterHours: darData?.maxCounterHours,
    //     darshanamName: darData?.name,
    //     description: darData?.description,
    //     counterEnabled: from === "counter" ? status : darData?.counterEnabled,
    //     onlineEnabled: from === "online" ? status : darData?.onlineEnabled,
    //     price: darData?.price,
    //     imageUrl: darData?.imageUrl,
    //   };
    //   await TmsDarshanamService.editDarshanam(key, body);
    //   setUpdateFlag(Math.random() + 1);
    // } catch (error) {
    //   catchErrorFunction(
    //     error,
    //     "Token Expired, redirecting to login page in 5 seconds",
    //     router
    //   );
    // }
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  useEffect(() => {
    if (router.location?.pathname === "/service-management/darshanam") {
      getDarshanam();
      if (!editFlag) {
        settmsModalVisible(false);
      }
    }
  }, [
    updateFlag,
    editFlag,
    tableCurrentPage,
    tablePageSize,
    router.location?.pathname,
  ]);

  const getDarshanam = async () => {
    setLoading(true);
    try {
      setDarshanamData([]);
      const data = await TmsDarshanamService.getDarshanam(
        tableCurrentPage,
        tablePageSize
      );
      setTabelTotalSize(data?.meta?.totalItems);
      setDarshanamData(
        data?.items?.map((item) => {
          return {
            key: item.id,
            ...item,
          };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Darshanam Name",
      dataIndex: "name",
      key: "name",
      //   ...getColumnSearchProps("darshanam_name"),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      sorter: (a, b) => a.price > b.price,
      render: (text) => {
        return `Rs. ${text}`;
      },
    },
    {
      title: "POS",
      children: [
        {
          title: "Booking",
          dataIndex: "maxCounterBookings",
          key: "maxCounterBookings",
          sorter: (a, b) => a.maxCounterBookings > b.maxCounterBookings,
        },
        {
          title: "Status",
          dataIndex: "counterEnabled",
          key: "counterEnabled",
          render: (text, record) => {
            return (
              <Switch
                size={"small"}
                checked={text}
                style={{ background: text ? "#4CBB17" : "EFEFEF" }}
                onClick={() => {
                  switchTrigger(record?.key, !text, "counter");
                }}
              />
            );
          },
        },
      ],
    },
    {
      title: "Online",
      children: [
        {
          title: "Booking",
          dataIndex: "maxOnlineBookings",
          key: "maxOnlineBookings",
          sorter: (a, b) => a.maxOnlineBookings > b.maxOnlineBookings,
        },
        {
          title: "Min (Hours)",
          dataIndex: "minOnlineHours",
          key: "minOnlineHours",
          sorter: (a, b) => a.minOnlineHours > b.minOnlineHours,
        },
        {
          title: "Max (Hours)",
          dataIndex: "maxOnlineHours",
          key: "maxOnlineHours",
          sorter: (a, b) => a.maxOnlineHours > b.maxOnlineHours,
        },
        {
          title: "Status",
          dataIndex: "onlineEnabled",
          key: "onlineEnabled",
          render: (text, record) => {
            return (
              <Switch
                size={"small"}
                checked={text}
                style={{
                  background: text ? "#4CBB17 " : "EFEFEF ",
                }}
                onClick={() => {
                  switchTrigger(record?.key, !text, "online");
                }}
              />
            );
          },
        },
      ],
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <TmsDInnerPagesActions
            record={record}
            setLoading={setLoading}
            setViewDarshanamData={setViewDarshanamData}
            settmsModalVisible={settmsModalVisible}
            setUpdateFlag={setUpdateFlag}
            setEditFlag={setEditFlag}
            setProductId={setProductId}
            setShowDrawer={setShowDrawer}
            setTermsData={setTermsData}
            setOnlineTermsData={setOnlineTermsData}
            setMiniTicket={setMiniTicket}
          />
        );
      },
    },
  ];

  return (
    <>
      {" "}
      <TmsTable
        columns={columns}
        loading={loading}
        dataSource={darshanamData}
        handleTableChange={handleTableChange}
        pagination={{
          total: tableTotalSize,
          current: tableCurrentPage,
          pageSize: tablePageSize,
        }}
      />
      <TmsDrawer
        className="DetailsModal"
        width={editFlag ? "800px" : "600px"}
        visible={tmsModalVisible}
        onClose={() => {
          settmsModalVisible(false);
          setEditFlag(false);
          setViewDarshanamData(null);
        }}
        title={editFlag ? "Edit Darshanam" : "Darshanam Details"}
      >
        {editFlag ? (
          <TmsDInnerPagesAnd
            viewDarshanamData={viewDarshanamData}
            editFlag={editFlag}
            productId={productId}
            setEditFlag={setEditFlag}
            settmsModalVisible={settmsModalVisible}
          />
        ) : (
          <div className="viewDetails">
            <Col style={{ width: "100%" }}>
              <table className="DetailsTable">
                {tableColums.map((item) => {
                  return (
                    <tr key={"table" + item[0]}>
                      <th>{item[0]}</th>
                      <td>{item[1]}</td>
                    </tr>
                  );
                })}
              </table>
            </Col>
            <br />
            <Col className="ImgCol">
              <img src={viewDarshanamData?.imageUrl} alt="Image" />
            </Col>
          </div>
        )}
      </TmsDrawer>
      <TmsDrawer
        className="TermsDrawer"
        visible={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setTermsData([]);
          setOnlineTermsData([]);
        }}
        title="Terms & Conditions"
        extra={
          <Button
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                await TmsDarshanamService.updateTerms(
                  productId,
                  termsData?.toString()?.replaceAll(",", "\n")?.split("\n"),
                  onlinetermsData
                    ?.toString()
                    ?.replaceAll(",", "\n")
                    ?.split("\n"),
                  miniTicket
                );
                setUpdateFlag(Math.random() + 1);
                setShowDrawer(false);
                setTermsData([]);
                setOnlineTermsData([]);
                setMiniTicket(false);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
          >
            Submit
          </Button>
        }
      >
        POS
        <TextArea
          maxLength={2200}
          rows={5}
          value={termsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setTermsData(e.target.value);
          }}
        />
        <br />
        <br />
        Online
        <TextArea
          maxLength={2200}
          rows={5}
          value={onlinetermsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setOnlineTermsData(e.target.value);
          }}
        />
        <Row className="formRow" style={{ width: "100%", paddingTop: "10px" }}>
          <Checkbox
            style={{ paddingRight: "10px" }}
            checked={miniTicket}
            onChange={(e) => setMiniTicket(e.target.checked)}
          />
          <label>Mini ticket</label>
        </Row>
      </TmsDrawer>
    </>
  );
};

export default withRouter(TmsDInnerPagesAll);
